import { createElement } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import React from 'react'

// Make React available globally for JSX transform compatibility
if (typeof window !== 'undefined') {
  window.React = React
}

import './i18n'
import Root from './Root'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'

declare global {
  interface Window {
    __APP_ENV__?: Record<string, string>
  }
}

if (typeof window !== 'undefined') {
  window.__APP_ENV__ = {
    ...(window.__APP_ENV__ ?? {}),
    ...import.meta.env,
  }
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, createElement(Root))
} else {
  createRoot(rootElement).render(createElement(Root))
}

serviceWorkerRegistration.register()
